import Layout from "@/components/feature/Layout";
import PageSEO from "@/components/feature/PageSEO";
import SectionHeading from "@/components/feature/SectionHeading";
import MovieGrid from "@/components/feature/MovieGrid";
import Toast from "@/components/base/Toast";
import { useToast } from "@/hooks/useToast";
import { getFeatured, getHot, getLatest } from "@/utils/movie";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import IntroSection from "@/pages/home/components/IntroSection";

export default function Home() {
  const { message, show } = useToast();
  const featured = getFeatured();
  const latest = getLatest(10);
  const hot = getHot(10);

  return (
    <Layout>
      <PageSEO
        title="熊猫影院-最新电影电视剧在线观看平台"
        description="熊猫影院提供丰富的电影和电视剧内容，涵盖各种热门影视资源，用户可在线查询和观看多类型作品，享受优质观影体验。"
        keywords="熊猫影院,在线电影,电视剧观看,影视资源,高清电影,影视大全,电影下载"
        path="/"
      />

      <h1 className="sr-only">熊猫影院 - 最新电影电视剧在线观看平台</h1>

      <HeroCarousel movies={featured} onAction={show} />

      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <section className="pt-12 md:pt-16">
          <SectionHeading
            title="分类快捷入口"
            subtitle="按你感兴趣的类别，快速找到想看的内容"
          />
          <CategoryEntries />
        </section>

        <section className="pt-14 md:pt-20">
          <SectionHeading
            title="最新上线"
            icon="ri-fire-line"
            subtitle="按上线时间倒序更新的最新影视作品"
            moreTo="/category/movie"
          />
          <MovieGrid movies={latest} columns={5} />
        </section>

        <section className="pt-14 md:pt-20">
          <SectionHeading
            title="热门推荐"
            icon="ri-bar-chart-box-line"
            subtitle="根据播放热度精选的高人气影视作品"
            moreTo="/category/tv"
          />
          <MovieGrid movies={hot} columns={5} />
        </section>

        <section className="pt-14 md:pt-20">
          <IntroSection />
        </section>
      </div>

      <Toast message={message} />
    </Layout>
  );
}